import { style } from 'typestyle';

export const columnFlex = style({
  display: 'flex',
  flexDirection: 'column'
});
